"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneyFormatter = void 0;
const tslib_1 = require("tslib");
const axios_1 = require("axios");
const symbols_1 = require("./symbols");
exports.default = axios_1.default;
class MoneyFormatter {
    constructor() {
        this.formats = [];
    }
    format(amount, locale) {
        const localeMoneyFormat = this.getLocaleMoneyFormat(locale);
        if (localeMoneyFormat === undefined) {
            return `${amount}`;
        }
        return this.getNumberFormatter(amount, localeMoneyFormat.currency, locale, localeMoneyFormat.numberOfDecimals);
    }
    formatWithCurrency(amount, currency, locale) {
        const localeMoneyFormat = this.getLocaleMoneyFormat(locale);
        if (localeMoneyFormat === undefined) {
            return `${amount} ${currency}`;
        }
        return this.getNumberFormatter(amount, currency, locale, localeMoneyFormat.numberOfDecimals);
    }
    getLocaleMoneyFormat(fromLocale) {
        const companyMoneyFormat = MoneyFormatter.instance.formats.find((pattern) => pattern.locale === fromLocale);
        if (!companyMoneyFormat) {
            return;
        }
        return Object.assign(Object.assign({}, companyMoneyFormat), { currencySymbol: symbols_1.currencySymbols[companyMoneyFormat.currency] });
    }
    getFormattedAmount(fromAmount, pattern) {
        return fromAmount
            .toFixed(pattern.numberOfDecimals)
            .replace('.', pattern.decimalSeparator);
    }
    getNumberFormatter(amount, currencyCode, fullLocale, numberOfDecimals) {
        if (amount % 1 == 0) {
            return new Intl.NumberFormat(fullLocale, {
                style: 'currency',
                currency: currencyCode,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }).format(amount);
        }
        return new Intl.NumberFormat(fullLocale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: numberOfDecimals,
        }).format(amount);
    }
}
exports.MoneyFormatter = MoneyFormatter;
_a = MoneyFormatter;
MoneyFormatter.GetInstanceAsnyc = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (!MoneyFormatter.instance) {
        MoneyFormatter.instance = new MoneyFormatter();
        const result = yield axios_1.default.get(MoneyFormatter.basePath);
        MoneyFormatter.instance.formats = result.data;
        return MoneyFormatter.instance;
    }
    return MoneyFormatter.instance;
});
MoneyFormatter.basePath = 'https://www.sembo.com/d/mvc/Companies/GetCompanies';
//# sourceMappingURL=index.js.map